import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  BaseCoreState,
  baseRelatedCustomerLocationsActions,
  baseRelatedCustomerLocationsSelectors,
} from '../../_store';
import { BaseLocationsListPayloadInterface } from '../interfaces/base-locations-list-payload.interface';

@Injectable({ providedIn: 'root' })
export class BaseLocationsListGuard {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.store.dispatch(
      baseRelatedCustomerLocationsActions.loadRelatedCustomerLocations({
        payload: route.queryParams as BaseLocationsListPayloadInterface,
      })
    );

    return this.store.select(baseRelatedCustomerLocationsSelectors.getRelatedCustomerLocationsList).pipe(
      filter((result) => result.ok !== undefined),
      map((result) => !!result.ok)
    );
  }
}
